import { PAGE_NAME } from 'utils/constants';
export const nameSpace = PAGE_NAME.TEMPLATE_TASKS;
